import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Users, Tag, UserCog, LogOut, Download, ClipboardList, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

export const Layout = ({ children, title }) => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const navItems = [
    { to: "/customers", icon: Users, label: "Kunden" },
    { to: "/todo", icon: ClipboardList, label: "ToDo" },
    { to: "/tags", icon: Tag, label: "Tags" },
    { to: "/import", icon: Download, label: "Import" },
    { to: "/trash", icon: Trash2, label: "Papierkorb" },
  ];

  if (isAdmin) {
    navItems.push({ to: "/users", icon: UserCog, label: "Benutzer" });
  }

  return (
    <TooltipProvider>
      <div className="min-h-screen bg-slate-50">
        {/* Sidebar */}
        <aside className="sidebar" data-testid="sidebar">
          <div className="p-6 border-b border-slate-100">
            <div className="flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_crm-central-43/artifacts/b97ilqpc_image.png" 
                alt="Makrolog Logo" 
                className="h-12 object-contain"
              />
            </div>
          </div>
          
          <nav className="p-3 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `sidebar-item ${isActive ? "active" : ""}`
                }
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-100 bg-white">
            <div className="flex items-center gap-3 mb-3 px-2">
              <div className="w-9 h-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-semibold text-sm">
                {user?.name?.charAt(0)?.toUpperCase() || "U"}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900 truncate">{user?.name}</p>
                <p className="text-xs text-slate-500 truncate">{user?.email}</p>
              </div>
            </div>
            <Button
              variant="ghost"
              className="w-full justify-start text-slate-600 hover:text-slate-900 hover:bg-slate-50"
              onClick={handleLogout}
              data-testid="logout-btn"
            >
              <LogOut size={18} className="mr-2" />
              Abmelden
            </Button>
          </div>
        </aside>

        {/* Main Content */}
        <main className="main-content">
          <header className="app-header">
            <h2 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h2>
          </header>
          <div className="p-8">
            {children}
          </div>
        </main>
      </div>
    </TooltipProvider>
  );
};

export default Layout;
